module.exports = __webpack_public_path__ + "b76f964125c606830352fb0cabf9f8f6.jpg";


//////////////////
// WEBPACK FOOTER
// ./assets/imgs/offices_Sthlm.jpg
// module id = 206
// module chunks = 0